export const MIN_REPLY_LENGTH = 20
export const MAX_REPLY_LENGTH = 600

export const DEFAULT_REPLY_BUTTON_LABEL = 'Responder'
export const DEFAULT_REPORT_BUTTON_LABEL = 'Denunciar'

export const DEFAULT_REPLY_FORM_CANCEL_BUTTON_LABEL = 'Cancelar'
export const DEFAULT_REPLY_FORM_HELP_TEXT = `caracteres (mínimo ${MIN_REPLY_LENGTH})`
export const DEFAULT_REPLY_FORM_PLACEHOLDER = 'Escribe tu respuesta...'
export const DEFAULT_REPLY_FORM_SUBMIT_BUTTON_LABEL = 'Enviar'

export const REPLY_FORM_ID = 'card-rating-reply'

export const BASE_CLASS = 'mt-CardRating'

export const NO_OP = () => {}
